module.exports = __webpack_public_path__ + "img/eco-qr-code.a599476b.png";